import { Button, Modal } from "@vimeo/iris/components";

import { DismissX } from "@vimeo/iris/icons";

interface Props {
    onCloseClicked: () => void;
    title: string;
}

export function ModalHeader(props: Props) {
    const { onCloseClicked, title } = props;

    return (
        <Modal.Header>
            <div
                style={{
                    display: "flex",
                    flexFlow: "row nowrap",
                    justifyContent: "space-between",
                }}
            >
                <span>{title}</span>
                <Button
                    format="secondary"
                    variant="minimal"
                    icon={<DismissX color="#1A2E3B" />}
                    onClick={onCloseClicked}
                ></Button>
            </div>
        </Modal.Header>
    );
}
